import React from 'react'
import { Col, Flex, Row, Typography } from 'antd'
import { UnderlineDesign } from '../UnderlineDesign'


const { Title, Text } = Typography
const Vision = () => {
  return (
    <div className='padding-t'>
        <div className='container'>
            <Row gutter={[64, 24]} align={'middle'}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <Flex vertical gap={20}>
                        <Flex vertical>
                            <Title level={2} className='m-0 gradient-text'>Our Vision</Title>
                            <UnderlineDesign />
                        </Flex>
                        <Text className='fs-16 text-justify'>
                        We envision a world where finding the right pro is simple, transparent, and stress-free. By empowering professionals and streamlining the client experience, we’re not just building spaces—we’re building trust, relationships, and lasting impact.
                        </Text>
                    </Flex>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <div>
                        <img src="assets/images/vision.jpg" width={'100%'} className='rounded' alt="" />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {Vision}